import { useMemo } from 'react'
import * as React from 'react'
import IfOwnedCourse from '@components/atoms/IfOwnedCourse/IfOwnedCourse'
import Link from 'next/link'
import Button from '@components/atoms/Button'
// import Icon from '@public/static/Icon'
import { colors } from '@configs/styles/config'
import { ShortCourse } from '@ugu/types'
import { formatPrice } from '@utils/formatPrice'
import { useAuth } from '@contexts/Auth'
import { useCartAndWishList } from '@contexts/CartAndWishList'
import useWindowDimensions from '@hooks/useWindowDimensions'
import dynamic from 'next/dynamic'
import { useTranslation } from 'react-i18next'
const ContinueLearningButton = dynamic(
  () =>
    import('@components/atoms/ContinueLearningButton/ContinueLearningButton')
)
import CartIcon from '@public/static/icons/headerIcons/cart-icon'
import WishlistIcon from '@public/static/icons/headerIcons/wishlist-icon'
import styled from '@emotion/styled'

type Props = {
  course: ShortCourse
  setShowCheckoutModal:
    | React.Dispatch<React.SetStateAction<boolean>>
    | undefined
}

const HomeFooter = ({ course, setShowCheckoutModal }: Props) => {
  const {
    isRemoving,
    addToCart,
    addToWishlist,
    removeFromWishlist,
    cartItems,
    wishlistItems,
  } = useCartAndWishList()
  const { user } = useAuth()
  const { width } = useWindowDimensions()
  const { t } = useTranslation('home')

  const inCart = useMemo(
    () =>
      Array.isArray(cartItems)
        ? cartItems?.some((item) => item?._id === course?._id)
        : [],
    [cartItems, course?._id]
  )
  const inWishlist = useMemo(
    () =>
      Array.isArray(wishlistItems)
        ? wishlistItems?.some((item) => item?._id === course?._id)
        : [],
    [wishlistItems, course?._id]
  )

  const handleCartButton = () => {
    if (course) {
      if (!inCart) addToCart(course)
      if (setShowCheckoutModal) setShowCheckoutModal((status) => !status)
      // setInCart(true)
    }
  }
  const handleWishlistButton = () => {
    if (course) {
      !inWishlist ? addToWishlist(course) : removeFromWishlist(course?._id)
      // setInWishlist(!inWishlist)
    }
  }

  const isMobile = width < 640

  return (
    <BottomWrapper>
      <PriceWrapper>
        <IfOwnedCourse hide id={course?._id}>
          <CoursePrice className="font-bold">
            {course?.salePrice || course?.price
              ? formatPrice(course?.salePrice || course?.price) +
                t('courseInfo.currency')
              : 'Free'}
          </CoursePrice>
          {course?.salePrice && (course?.salePrice || 0) < course?.price && (
            <OriginalPrice className="font-light">
              {formatPrice(course.price) + ' USD'}
            </OriginalPrice>
          )}
        </IfOwnedCourse>
      </PriceWrapper>
      <ButtonsWrapper>
        {user?.purchased_courses?.includes(course?._id) ? (
          <ContinueLearningButton
            ViewMode="verticalCard"
            courseId={course?._id}
            courseTitle={course?.title}
          />
        ) : (
          <>
            {user?.my_courses?.includes(course?._id) ? (
              <Link
                href={'/create-course/' + course?._id}
                className="text-sm leading-[37px] h-[35px] w-[109px] rounded-lg text-center text-uguBrightPurple bg-[#E1E5FF] font-semiBold"
              >
                Manage
              </Link>
            ) : (
              <>
                <Button
                  backgroundColor={
                    inWishlist ? colors.uguLightRed : colors.uguLightLightGrey
                  }
                  width={isMobile ? '40px' : '37px'}
                  height={isMobile ? '40px' : '37px'}
                  minHeight="37px"
                  borderRadius="50%"
                  zIndex={1}
                  marginRight="0.7rem"
                  onClick={handleWishlistButton}
                  ariaLabel={`Add ${course?.title} to wishlist`}
                  disabled={isRemoving.type === 'wishlist'}
                >
                  {/* <Icon
                    name="headericons-wishlist-icon"
                    width={isMobile ? '21.5px' : '18px'}
                    height="100%"
                    color={inWishlist ? colors.uguRed : colors.uguPurple}
                  /> */}
                  <WishlistIcon
                    width={isMobile ? '19' : '18px'}
                    height={isMobile ? '19' : '18px'}
                    color={inWishlist ? colors.uguRed : colors.uguPurple}
                  />
                </Button>
                <Button
                  backgroundColor={
                    inCart ? '#E1E5FF' : colors.uguLightLightGrey
                  }
                  width={isMobile ? '40px' : '37px'}
                  height={isMobile ? '40px' : '37px'}
                  borderRadius="50%"
                  zIndex={1}
                  onClick={handleCartButton}
                  ariaLabel={`Add ${course?.title} to cart`}
                  disabled={isRemoving.type === 'cart'}
                >
                  {/* <Icon
                    name="headericons-cart-icon"
                    width={isMobile ? '21.5px' : '18px'}
                    height="100%"
                    color={inCart ? 'rgba(113, 129, 255, 1)' : colors.uguPurple}
                  /> */}
                  <CartIcon
                    width={isMobile ? '23.5px' : '18px'}
                    color={inCart ? 'rgba(113, 129, 255, 1)' : colors.uguPurple}
                  />
                </Button>
              </>
            )}
          </>
        )}
      </ButtonsWrapper>
    </BottomWrapper>
  )
}

export default HomeFooter

const BottomWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 45px;
`
const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  z-index: 1;
`

const PriceWrapper = styled.div`
  display: flex;
  /* height: 15%; */
  flex-direction: column;
  justify-content: space-between;
`
const CoursePrice = styled.span`
  display: flex;
  align-items: flex-end;
  color: ${colors.uguPurple};
  height: 60%;
  font-size: 0.9rem;
  @media screen and (max-width: 640px) {
    font-size: 1.1rem;
  }
`
const OriginalPrice = styled.span`
  display: flex;
  color: ${colors.uguPurple};
  height: 40%;
  font-size: 0.8rem;
  text-decoration: line-through;
`
